export function stripMask(value: string): string {
  return value.replace(/\D/g, "");
}

export function parseCpf(value: string): string {
  return stripMask(value).slice(0, 11);
}

export function parseCnpj(value: string): string {
  return stripMask(value).slice(0, 14);
}

export function parsePhone(value: string): string {
  return stripMask(value).slice(0, 11);
}

export function parseCep(value: string): string {
  return stripMask(value).slice(0, 8);
}

/** Converte "R$ 1.234,56" em number 1234.56. Retorna NaN se vazio. */
export function parseCurrency(value: string): number {
  const digits = stripMask(value);
  if (!digits) return NaN;
  return Number(digits) / 100;
}
